import React, { useState, useEffect } from "react";
import { Routes, Route, useNavigate } from "react-router-dom";
import { isBrowser } from "react-device-detect";
import { useSelector, useDispatch } from "react-redux";
import Axios from "axios";

//STYLES
import * as UserRouteSystemStyles from "./styles/userRouteSystem";

//ACTIONS
import * as UserActions from "../../store/actions/user";
import * as GS_generalSettings from "../../store/actions/globalSettings/GS_generalSettings";

import EnvironmentPodsMap from "../pods/environmentPodsMap";

//USER SIDE
import BrowserNavBar from "../pods/special/navBar/browserNavBar";
import MobileNavBar from "../pods/special/navBar/mobileNavBar";
import SiteOffline from "../../administration/pods/siteOffline/files/siteOffline";

//FROM ADMIN CORE SIDE
import AdminBanner from "../../administration/pods/adminBanner/adminBanner";

import Home from "../pods/developmentHub/files/home";
import PodView from "../pods/developmentHub/files/podView";
import PageView from "../pods/developmentHub/files/pageView";

function UserRouteSystem() {
    const user = useSelector((state) => state.user);

    const [isLoaded, setIsLoaded] = useState(false);
    const [isOffline, setIsOffline] = useState(false);
    const [membership, setMembership] = useState(false);

    const dispatch = useDispatch();
    const navigate = useNavigate();

    useEffect(() => {
        onOpen();
    }, []);

    function onOpen() {
        Axios.post("/pods/userRouter/getOpeningData")
            .then((res) => {
                const data = res.data;
                dispatch(GS_generalSettings.UpdateMainContactPageVisible(data.settings.mainContactPage.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOffline(data.settings.siteOffline.value == "true"));
                dispatch(GS_generalSettings.UpdateSiteOfflineMessage(data.settings.siteOffline.subValue));
                setIsOffline(data.settings.siteOffline.value == "true");

                if (user.auth && user.type !== "registered") {
                    dispatch(UserActions.UpdateAdminSignedIn(true));
                }

                //MEMBERSHIP EXTRA POD
                if (user.requestedPassword) {
                    navigate("/membership/changePassword");
                }

                setIsLoaded(true);
            })
            .catch((err) => console.log(err));
    }

    function offlineUserCheck(role) {
        if (role == "modifier" || role == "registered" || role == "") {
            return false;
        } else {
            return true;
        }
    }

    return (
        <div>
            {isLoaded && (
                <div>
                    {isOffline && !offlineUserCheck(user.type) ? (
                        <div>
                            <SiteOffline />
                        </div>
                    ) : (
                        <div style={UserRouteSystemStyles.body}>
                            {user.adminSignedIn ? <AdminBanner /> : null}
                            {isBrowser ? <BrowserNavBar membership={membership} setMembership={setMembership} /> : <MobileNavBar />}
                            <Routes>
                                <Route path="/" exact element={<Home />} />
                                <Route path="/pod/:pod/*" element={<PodView setMembership={setMembership} />} />
                                <Route path="/page/:page/*" element={<PageView />} />
                            </Routes>
                        </div>
                    )}
                </div>
            )}
        </div>
    );
}

export default UserRouteSystem;
